/**
 * Atelier logo — uses the uploaded PNG as a CSS mask so the color
 * automatically adapts to the current theme (ink on light, cream on dark)
 * via `background-color: currentColor`.
 */
export default function Logo({ size = 36, color = "currentColor", className = "" }) {
  const style = {
    width: size,
    height: size,
    backgroundColor: color,
    WebkitMaskImage: "url(/logo.png)",
    maskImage: "url(/logo.png)",
    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
    WebkitMaskPosition: "center",
    maskPosition: "center",
    WebkitMaskSize: "contain",
    maskSize: "contain",
    display: "inline-block",
    flexShrink: 0,
  };
  return <span style={style} className={className} role="img" aria-label="606MEDIADOCS" />;
}
